import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPhone} from '@fortawesome/free-solid-svg-icons';
import { faPerson, faPersonDress, faXmark, faCheck } from '@fortawesome/free-solid-svg-icons';

function Reporting_date() {
        const [name, setName] = useState('')
        const [date, setDate] = useState('')
        const [phone, setPhone] = useState('')
        const [altphone, setAltphone] = useState('')
    
 
        const [loading, setLoading] = useState(false)

        const scroll = () =>{

            if (name==''||date==''||phone==''||altphone=='') {
                
                if(name=='')alert('please add your name')
                if(date=='') alert('please add your expected report date')
                if(altphone=='') alert('please add your school alternative phone number')
            
                if(phone=='') alert('please add your phone number')
            
    
            } else

            {
                setLoading(true)
                fetch('https://hosteladventures.site/PHP/Booking/Expected_date.php', {
                   method: 'POST',
                   headers: {
                     'Content-Type': 'application/json'
                   },
                   body: JSON.stringify({
                      name,
                      phone,
                      altphone,
                      date,
                  
                   })
                 })
                   .then(response => response.json())
                   .then(data => {
                     // Handle response from backend (e.g., login success or failure)
                     if(data.message=='in')
                     {
                       setLoading(false)
                       alert('Thank you for booking with us, we will contact you within the next 24 hours')
                     }
     
                    
                  
                   })
                   .catch(error => {
                     console.error('Error:', error);
                     alert('Error Uploading,!! Check Internet Connection')
                     setLoading(false)
                   });
            }

        }
  return (
           <div className='Form_HBK'>
               <p className='fill_In'>Expected Reporting Date</p>
               <input placeholder='Student Name' onChange={(event) => setName(event.target.value)} />
               <input placeholder='Phone Number' onChange={(event) => setPhone(event.target.value)}/>
               <input placeholder='Aternative Phone Number' onChange={(event) => setAltphone(event.target.value)} />
               
               <div>
                <div className='DOM_PH'>Expected Date:</div>
                  <input type='date' placeholder='date of admission' onChange={(event) => setDate(event.target.value)} />
                </div>
              
              {!loading?(<div className='submit' onClick={scroll}>Submit</div>):(<div className='submit'>Loading...</div>)}
               
               
           </div>
  )
}

export default Reporting_date
